import * as Types from 'src/actions/aptitude-test/get/Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'src/reducers/RootReducer';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { AxiosResponse } from 'axios';
import AptitudeTest from 'src/entities/AptitudeTest';

export interface GetAptitudeTestAttempt extends Action {
  type: Types.GET_APTITUDE_TEST_ATTEMPT;
}

export interface GetAptitudeTestSuccess extends Action {
  type: Types.GET_APTITUDE_TEST_SUCCESS;
  payload: AptitudeTest;
}

export interface GetAptitudeTestFailure extends Action {
  type: Types.GET_APTITUDE_TEST_FAILURE;
  payload: {};
}

export type GetAptitudeTestAction = GetAptitudeTestAttempt | GetAptitudeTestSuccess | GetAptitudeTestFailure;

export interface GetAptitudeTestThunk extends ThunkAction<Promise<GetAptitudeTestAction>, RootState, null> {
}

export const getAptitudeTestAttempt: ActionCreator<GetAptitudeTestAttempt> = () => (
  {type: Types.GET_APTITUDE_TEST_ATTEMPT}
);

export const getAptitudeTestSuccess: ActionCreator<GetAptitudeTestSuccess> = (aptitudeTest: AptitudeTest) => (
  {
    type: Types.GET_APTITUDE_TEST_SUCCESS,
    payload: aptitudeTest
  }
);

export const getAptitudeTestFailure: ActionCreator<GetAptitudeTestFailure> = (error: {}) => (
  {
    type: Types.GET_APTITUDE_TEST_FAILURE,
    payload: error
  }
);

export const getAptitudeTest: ActionCreator<GetAptitudeTestThunk> = (
  aptitudeTestName: string
): GetAptitudeTestThunk => {

  return (dispatch: Dispatch<RootState>): Promise<GetAptitudeTestAction> => {
    dispatch(getAptitudeTestAttempt());

    return ApiClient.aptitudeTest.get(aptitudeTestName)
      .then((response: AxiosResponse<AptitudeTest>): GetAptitudeTestSuccess => {

        const aptitudeTest: AptitudeTest = response.data;

        return dispatch(getAptitudeTestSuccess(aptitudeTest));
      }).catch((e: {response: {data: {error: Error}}}): GetAptitudeTestFailure => {
        const errorMessages = e && e.response && e.response.data && e.response.data.error || {
          serverConnection: 'Error en la conexión, por favor inténtelo más tarde'
        };
        return dispatch(getAptitudeTestFailure(errorMessages));
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/aptitude-test/get/GetAptitudeTest.actions.tsx